import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  paddingLeft20: {
    paddingLeft: 20,
  },
  logo: {
    fill: theme.palette.neutralPrimary,
  },
  signatureImage: {
    borderRadius: 5,
    objectFit: 'contain', 
    backgroundColor: 'white'
  },
  customWidth: {
    width: '400px',
  },
  iconContainer: {
    width: 40
  },
  gray: {
    color: theme.palette.neutralSecondaryAlt,
  },
}));
